export const apiUrl =  process.env.REACT_APP_NODE_ENV === "development" ? process.env.REACT_APP_DEVELOPMENT_URL  :  process.env.REACT_APP_PRODUCTION_URL